"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivatePackageServiceServer = exports.PrivatePackageServiceDispatcher = exports.PrivatePackageServiceClient = void 0;
var Store_1 = require("./Store");
var MultiStorePackage_1 = require("./MultiStorePackage");
var services_shared_1 = require("@playq/services-shared");
var AppPackages_1 = require("./AppPackages");
var PackagesExistenceResponse_1 = require("./PackagesExistenceResponse");
var UpdatePackageRequest_1 = require("./UpdatePackageRequest");
var UnknownItemsFailure_1 = require("./UnknownItemsFailure");
var PackageID_1 = require("./PackageID");
var NotSupportedFailure_1 = require("./NotSupportedFailure");
var PackageNotFoundException_1 = require("./PackageNotFoundException");
var RegisterPackageRequest_1 = require("./RegisterPackageRequest");
var InRegisterPackage = (function () {
    function InRegisterPackage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.package_ = new RegisterPackageRequest_1.RegisterPackageRequest(data.package);
        this.registerIn = data.registerIn.map(function (e) { return Store_1.Store[e]; });
        this.id = typeof data.id !== 'undefined' ? new PackageID_1.PackageID(data.id) : undefined;
    }
    Object.defineProperty(InRegisterPackage.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterPackage.prototype, "package_", {
        get: function () {
            return this._package;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field package_ is not optional');
            }
            this._package = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterPackage.prototype, "registerIn", {
        get: function () {
            return this._registerIn;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field registerIn is not optional');
            }
            this._registerIn = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterPackage.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._id = undefined;
                return;
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRegisterPackage.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            package: this.package_.serialize(),
            registerIn: this.registerIn.map(function (e) { return Store_1.Store[e]; }),
            id: typeof this.id !== 'undefined' ? this.id.serialize() : undefined
        };
    };
    return InRegisterPackage;
}());
var OutRegisterPackageHelpers = (function () {
    function OutRegisterPackageHelpers() {
    }
    OutRegisterPackageHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof MultiStorePackage_1.MultiStorePackage || o instanceof NotSupportedFailure_1.NotSupportedFailure || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure;
    };
    OutRegisterPackageHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutRegisterPackageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'MultiStorePackage': return new MultiStorePackage_1.MultiStorePackage(content);
            case 'NotSupportedFailure': return new NotSupportedFailure_1.NotSupportedFailure(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutRegisterPackage');
        }
    };
    return OutRegisterPackageHelpers;
}());
var InUpdatePackage = (function () {
    function InUpdatePackage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.package_ = new UpdatePackageRequest_1.UpdatePackageRequest(data.package);
        this.registerIn = data.registerIn.map(function (e) { return Store_1.Store[e]; });
    }
    Object.defineProperty(InUpdatePackage.prototype, "package_", {
        get: function () {
            return this._package;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field package_ is not optional');
            }
            this._package = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdatePackage.prototype, "registerIn", {
        get: function () {
            return this._registerIn;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field registerIn is not optional');
            }
            this._registerIn = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdatePackage.prototype.serialize = function () {
        return {
            package: this.package_.serialize(),
            registerIn: this.registerIn.map(function (e) { return Store_1.Store[e]; })
        };
    };
    return InUpdatePackage;
}());
var OutUpdatePackageHelpers = (function () {
    function OutUpdatePackageHelpers() {
    }
    OutUpdatePackageHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof MultiStorePackage_1.MultiStorePackage || o instanceof NotSupportedFailure_1.NotSupportedFailure || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure;
    };
    OutUpdatePackageHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutUpdatePackageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'MultiStorePackage': return new MultiStorePackage_1.MultiStorePackage(content);
            case 'NotSupportedFailure': return new NotSupportedFailure_1.NotSupportedFailure(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutUpdatePackage');
        }
    };
    return OutUpdatePackageHelpers;
}());
var InUnregisterPackage = (function () {
    function InUnregisterPackage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new PackageID_1.PackageID(data.id);
    }
    Object.defineProperty(InUnregisterPackage.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnregisterPackage.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InUnregisterPackage;
}());
var OutUnregisterPackageHelpers = (function () {
    function OutUnregisterPackageHelpers() {
    }
    OutUnregisterPackageHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof services_shared_1.CommonSuccess || o instanceof services_shared_1.CommonFailure;
    };
    OutUnregisterPackageHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutUnregisterPackageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CommonSuccess': return new services_shared_1.CommonSuccess(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutUnregisterPackage');
        }
    };
    return OutUnregisterPackageHelpers;
}());
var InGetRegisteredPackages = (function () {
    function InGetRegisteredPackages(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
    }
    Object.defineProperty(InGetRegisteredPackages.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetRegisteredPackages.prototype.serialize = function () {
        return {
            app: this.app.serialize()
        };
    };
    return InGetRegisteredPackages;
}());
var OutGetRegisteredPackagesHelpers = (function () {
    function OutGetRegisteredPackagesHelpers() {
    }
    OutGetRegisteredPackagesHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof AppPackages_1.AppPackages || o instanceof services_shared_1.CommonFailure;
    };
    OutGetRegisteredPackagesHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetRegisteredPackagesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'AppPackages': return new AppPackages_1.AppPackages(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetRegisteredPackages');
        }
    };
    return OutGetRegisteredPackagesHelpers;
}());
var InGetPackage = (function () {
    function InGetPackage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new PackageID_1.PackageID(data.id);
    }
    Object.defineProperty(InGetPackage.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetPackage.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InGetPackage;
}());
var OutGetPackageHelpers = (function () {
    function OutGetPackageHelpers() {
    }
    OutGetPackageHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof MultiStorePackage_1.MultiStorePackage || o instanceof PackageNotFoundException_1.PackageNotFoundException || o instanceof services_shared_1.CommonFailure;
    };
    OutGetPackageHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetPackageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'MultiStorePackage': return new MultiStorePackage_1.MultiStorePackage(content);
            case 'PackageNotFoundException': return new PackageNotFoundException_1.PackageNotFoundException(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetPackage');
        }
    };
    return OutGetPackageHelpers;
}());
var InCheckExistenceOf = (function () {
    function InCheckExistenceOf(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new PackageID_1.PackageID(e); });
    }
    Object.defineProperty(InCheckExistenceOf.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    InCheckExistenceOf.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); })
        };
    };
    return InCheckExistenceOf;
}());
var OutCheckExistenceOfHelpers = (function () {
    function OutCheckExistenceOfHelpers() {
    }
    OutCheckExistenceOfHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof PackagesExistenceResponse_1.PackagesExistenceResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutCheckExistenceOfHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutCheckExistenceOfHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'PackagesExistenceResponse': return new PackagesExistenceResponse_1.PackagesExistenceResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutCheckExistenceOf');
        }
    };
    return OutCheckExistenceOfHelpers;
}());
var PrivatePackageServiceClient = (function () {
    function PrivatePackageServiceClient(transport) {
        this._transport = transport;
    }
    PrivatePackageServiceClient.prototype.getPackageName = function () { return PrivatePackageServiceClient.PackageName; };
    PrivatePackageServiceClient.prototype.getClassName = function () { return PrivatePackageServiceClient.ClassName; };
    PrivatePackageServiceClient.prototype.getFullClassName = function () { return PrivatePackageServiceClient.FullClassName; };
    PrivatePackageServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.prototype.registerPackage = function (app, package_, registerIn, id) {
        var _this = this;
        var __data = new InRegisterPackage();
        __data.app = app;
        __data.package_ = package_;
        __data.registerIn = registerIn;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, 'registerPackage', __data)
                .then(function (data) {
                try {
                    resolve(OutRegisterPackageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.prototype.updatePackage = function (package_, registerIn) {
        var _this = this;
        var __data = new InUpdatePackage();
        __data.package_ = package_;
        __data.registerIn = registerIn;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, 'updatePackage', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdatePackageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.prototype.unregisterPackage = function (id) {
        var _this = this;
        var __data = new InUnregisterPackage();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, 'unregisterPackage', __data)
                .then(function (data) {
                try {
                    resolve(OutUnregisterPackageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.prototype.getRegisteredPackages = function (app) {
        var _this = this;
        var __data = new InGetRegisteredPackages();
        __data.app = app;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, 'getRegisteredPackages', __data)
                .then(function (data) {
                try {
                    resolve(OutGetRegisteredPackagesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.prototype.getPackage = function (id) {
        var _this = this;
        var __data = new InGetPackage();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, 'getPackage', __data)
                .then(function (data) {
                try {
                    resolve(OutGetPackageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.prototype.checkExistenceOf = function (ids) {
        var _this = this;
        var __data = new InCheckExistenceOf();
        __data.ids = ids;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivatePackageServiceClient.ClassName, 'checkExistenceOf', __data)
                .then(function (data) {
                try {
                    resolve(OutCheckExistenceOfHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivatePackageServiceClient.PackageName = 'net.playq.services.bookkeeper';
    PrivatePackageServiceClient.ClassName = 'PrivatePackageService';
    PrivatePackageServiceClient.FullClassName = 'net.playq.services.bookkeeper.PrivatePackageService';
    return PrivatePackageServiceClient;
}());
exports.PrivatePackageServiceClient = PrivatePackageServiceClient;
var PrivatePackageServiceDispatcher = (function () {
    function PrivatePackageServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    PrivatePackageServiceDispatcher.prototype.getSupportedService = function () {
        return 'PrivatePackageService';
    };
    PrivatePackageServiceDispatcher.prototype.getSupportedMethods = function () {
        return PrivatePackageServiceDispatcher.methods;
    };
    PrivatePackageServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "registerPackage": {
                var obj_1 = new InRegisterPackage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.registerPackage(context, obj_1.app, obj_1.package_, obj_1.registerIn, obj_1.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRegisterPackageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updatePackage": {
                var obj_2 = new InUpdatePackage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updatePackage(context, obj_2.package_, obj_2.registerIn)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdatePackageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unregisterPackage": {
                var obj_3 = new InUnregisterPackage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unregisterPackage(context, obj_3.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnregisterPackageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getRegisteredPackages": {
                var obj_4 = new InGetRegisteredPackages(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getRegisteredPackages(context, obj_4.app)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetRegisteredPackagesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getPackage": {
                var obj_5 = new InGetPackage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getPackage(context, obj_5.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetPackageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "checkExistenceOf": {
                var obj_6 = new InCheckExistenceOf(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.checkExistenceOf(context, obj_6.ids)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCheckExistenceOfHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by PrivatePackageServiceDispatcher."));
        }
    };
    PrivatePackageServiceDispatcher.methods = [
        "registerPackage",
        "updatePackage",
        "unregisterPackage",
        "getRegisteredPackages",
        "getPackage",
        "checkExistenceOf"
    ];
    return PrivatePackageServiceDispatcher;
}());
exports.PrivatePackageServiceDispatcher = PrivatePackageServiceDispatcher;
var PrivatePackageServiceServer = (function (_super) {
    __extends(PrivatePackageServiceServer, _super);
    function PrivatePackageServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    PrivatePackageServiceServer.prototype.registerPackage = function (context, app, package_, registerIn, id) {
        throw new Error('Not implemented.');
    };
    PrivatePackageServiceServer.prototype.updatePackage = function (context, package_, registerIn) {
        throw new Error('Not implemented.');
    };
    PrivatePackageServiceServer.prototype.unregisterPackage = function (context, id) {
        throw new Error('Not implemented.');
    };
    PrivatePackageServiceServer.prototype.getRegisteredPackages = function (context, app) {
        throw new Error('Not implemented.');
    };
    PrivatePackageServiceServer.prototype.getPackage = function (context, id) {
        throw new Error('Not implemented.');
    };
    PrivatePackageServiceServer.prototype.checkExistenceOf = function (context, ids) {
        throw new Error('Not implemented.');
    };
    return PrivatePackageServiceServer;
}(PrivatePackageServiceDispatcher));
exports.PrivatePackageServiceServer = PrivatePackageServiceServer;
//# sourceMappingURL=PrivatePackageService.js.map